import React from 'react';

function Header() {
  return (
    <header>
      <h1>WikiSight</h1>
      <span>Search for page views on Wikipedia articles</span>
    </header>
  )
}

export default Header;
